import Vue from 'vue'
import VueRouter from 'vue-router'
// 主商城 mall
import mallIndex from '@/pages/mall/Index'
import mallDetail from '@/pages/mall/Detail'
import mallCategory from '@/pages/mall/Category'
import mallSearch from '@/pages/mall/Search'
import mallList from '@/pages/mall/List'
import mallEvaluateList from '@/pages/mall/EvaluateList'
import mallEvaluate from '@/pages/mall/Evaluate'
import mallMyEvaluate from '@/pages/mall/MyEvaluate'
import mallCollect from '@/pages/mall/Collect'
import mallCart from '@/pages/mall/Cart'
import mallOrder from '@/pages/mall/Order'
import mallMyOrder from '@/pages/mall/MyOrder'
import mallOrderDetail from '@/pages/mall/OrderDetail'
import mallLogistics from '@/pages/mall/Logistics'
// 优惠券 coupon
import couponIndex from '@/pages/coupon/Index'
import couponGive from '@/pages/coupon/Give'
import couponReceive from '@/pages/coupon/Receive'
import couponChoose from '@/pages/coupon/Choose'
// 地址 address
import addressIndex from '@/pages/address/Index'
import addressEdit from '@/pages/address/Edit'
// 个人中心
import mineIndex from '@/pages/mine/Index'
import mineAbout from '@/pages/mine/About'
import mineContact from '@/pages/mine/Contact'
import mineProblem from '@/pages/mine/Problem'
import mineProblemDetail from '@/pages/mine/ProblemDetail'
// 积分商城
import integralIndex from '@/pages/integral/Index'
import integralRecord from '@/pages/integral/Record'
import integralList from '@/pages/integral/List'
import integralDetail from '@/pages/integral/Detail'
import integralOrder from '@/pages/integral/Order'
import integralOrderDetail from '@/pages/integral/OrderDetail'
import integralRanking from '@/pages/integral/Ranking'
import integralDetailed from '@/pages/integral/Detailed'
import integralStrategy from '@/pages/integral/Strategy'
import integralWriteOff from '@/pages/integral/WriteOff'

// 拼团
import assembleIndex from '@/pages/assemble/Index'
import assembleDetail from '@/pages/assemble/Detail'
import assembleEvaluate from '@/pages/assemble/Evaluate'
import assembleMyEvaluate from '@/pages/assemble/MyEvaluate'
import assembleEvaluateList from '@/pages/assemble/EvaluateList'
import assembleOrder from '@/pages/assemble/Order'
import assembleMyOrder from '@/pages/assemble/MyOrder'
import assembleOrderDetail from '@/pages/assemble/OrderDetail'
import assembleRegiment from '@/pages/assemble/Regiment'
import assembleRegimentDetail from '@/pages/assemble/RegimentDetail'

// 意见反馈
import feedbackIndex from '@/pages/feedback/Index'
import feedbackDetail from '@/pages/feedback/Detail'
// 转盘
import turntableIndex from '@/pages/turntable/Index'
import turntableWinningRecord from '@/pages/turntable/WinningRecord'
import turntableWinningList from '@/pages/turntable/WinningList'
import turntablePerfectInfo from '@/pages/turntable/PerfectInfo'

import homepc from '@/pages/home/home'
import enquiriespc from '@/pages/enquiries/enquiries'
import queryresultspc from '@/pages/queryresults/queryresults'
import wx from '@/wx'

Vue.use(VueRouter)
let router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'homepc',
      component: homepc,
      meta: {
        title: 'IPA国际打击乐协会证书查询'
      }
    },
    {
      path: '/enquiriespc',
      name: 'enquiriespc',
      component: enquiriespc,
      meta: {
        title: 'IPA国际打击乐协会证书查询'
      }
    },
    {
      path: '/queryresultspc',
      name: 'queryresultspc',
      component: queryresultspc,
      meta: {
        title: 'IPA国际打击乐协会证书查询'
      }
    },
    {
      path: '/Mall/Index',
      name: 'mallIndex',
      component: mallIndex,
      meta: {
        title: '商城'
      }
    },
    {
      path: '/Mall/Detail/:id',
      name: 'mallDetail',
      component: mallDetail,
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/Mall/Category/:id',
      name: 'mallCategory',
      component: mallCategory,
      meta: {
        title: '商品分类'
      }
    },
    {
      path: '/Mall/Search',
      name: 'mallSearch',
      component: mallSearch,
      meta: {
        title: '商品搜索'
      }
    },
    {
      path: '/Mall/List/:first_category_id/:second_category_id',
      name: 'mallList',
      component: mallList,
      meta: {
        title: '商品列表'
      }
    },,
    {
      path: '/Mall/EvaluateList/:id',
      name: 'mallEvaluateList',
      component: mallEvaluateList,
      meta: {
        title: '全部评论'
      }
    },
    {
      path: '/Mall/Evaluate/:id',
      name: 'mallEvaluate',
      component: mallEvaluate,
      meta: {
        title: '商品评论'
      }
    },
    {
      path: '/Mall/MyEvaluate',
      name: 'mallMyEvaluate',
      component: mallMyEvaluate,
      meta: {
        title: '我的评价'
      }
    },
    {
      path: '/Mall/Collect',
      name: 'mallCollect',
      component: mallCollect,
      meta: {
        title: '我的收藏'
      }
    },
    {
      path: '/Mall/Cart',
      name: 'mallCart',
      component: mallCart,
      meta: {
        title: '购物车'
      }
    },
    {
      path: '/Mall/Order',
      name: 'mallOrder',
      component: mallOrder,
      meta: {
        title: '商品下单'
      }
    },
    {
      path: '/Coupon/Index',
      name: 'couponIndex',
      component: couponIndex,
      meta: {
        title: '优惠券'
      }
    },
    {
      path: '/Coupon/Give',
      name: 'couponGive',
      component: couponGive,
      meta: {
        title: '兑换优惠券'
      }
    },
    {
      path: '/Coupon/Choose',
      name: 'couponChoose',
      component: couponChoose,
      meta: {
        title: '选择优惠券'
      }
    },
    {
      path: '/Coupon/Receive',
      name: 'couponReceive',
      component: couponReceive,
      meta: {
        title: '领取优惠券'
      }
    },
    {
      path: '/Mall/MyOrder',
      name: 'mallMyOrder',
      component: mallMyOrder,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/Mall/OrderDetail',
      name: 'mallOrderDetail',
      component: mallOrderDetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/Mall/Logistics/:id',
      name: 'mallLogistics',
      component: mallLogistics,
      meta: {
        title: '物流信息'
      }
    },
    {
      path: '/Address/Index',
      name: 'addressIndex',
      component: addressIndex,
      meta: {
        title: '我的地址'
      }
    },
    {
      path: '/Address/Edit/:id',
      name: 'addressEdit',
      component: addressEdit,
      meta: {
        title: '地址信息'
      }
    },
    {
      path: '/Mine/Index',
      name: 'mineIndex',
      component: mineIndex,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/Mine/About',
      name: 'mineAbout',
      component: mineAbout,
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/Mine/Contact',
      name: 'mineContact',
      component: mineContact,
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '/Mine/Problem',
      name: 'mineProblem',
      component: mineProblem,
      meta: {
        title: '常见问题'
      }
    },
    {
      path: '/Mine/ProblemDetail/:id',
      name: 'mineProblemDetail',
      component: mineProblemDetail,
      meta: {
        title: '问题详情'
      }
    },
    {
      path: '/Integral/Index',
      name: 'integralIndex',
      component: integralIndex,
      meta: {
        title: '积分商城'
      }
    },
    {
      path: '/Integral/List/:id',
      name: 'integralList',
      component: integralList,
      meta: {
        title: '商品列表'
      }
    },
    {
      path: '/Integral/Detail/:id',
      name: 'integralDetail',
      component: integralDetail,
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/Integral/Record',
      name: 'integralRecord',
      component: integralRecord,
      meta: {
        title: '兑换记录'
      }
    },
    {
      path: '/Integral/Order',
      name: 'integralOrder',
      component: integralOrder,
      meta: {
        title: '下单'
      }
    },
    {
      path: '/Integral/OrderDetail/:id',
      name: 'integralOrderDetail',
      component: integralOrderDetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/Integral/Detailed',
      name: 'integralDetailed',
      component: integralDetailed,
      meta: {
        title: '我的积分'
      }
    },
    {
      path: '/Integral/Ranking',
      name: 'integralRanking',
      component: integralRanking,
      meta: {
        title: '积分排行榜'
      }
    },
    {
      path: '/Integral/Strategy',
      name: 'integralStrategy',
      component: integralStrategy,
      meta: {
        title: '积分攻略'
      }
    },
    {
      path: '/Integral/WriteOff',
      name: 'integralWriteOff',
      component: integralWriteOff,
      meta: {
        title: '订单核销'
      }
    },
    {
      path: '/Assemble/Index',
      name: 'assembleIndex',
      component: assembleIndex,
      meta: {
        title: '拼团商城'
      }
    },
    {
      path: '/Assemble/Detail/:id',
      name: 'assembleDetail',
      component: assembleDetail,
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/Assemble/MyEvaluate',
      name: 'assembleMyEvaluate',
      component: assembleMyEvaluate,
      meta: {
        title: '我的评价'
      }
    },
    {
      path: '/Assemble/Evaluate/:id',
      name: 'assembleEvaluate',
      component: assembleEvaluate,
      meta: {
        title: '评价'
      }
    },
    {
      path: '/Assemble/EvaluateList/:id',
      name: 'assembleEvaluateList',
      component: assembleEvaluateList,
      meta: {
        title: '全部评价'
      }
    },
    {
      path: '/Assemble/Order',
      name: 'assembleOrder',
      component: assembleOrder,
      meta: {
        title: '下单'
      }
    },
    {
      path: '/Assemble/MyOrder',
      name: 'assembleMyOrder',
      component: assembleMyOrder,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/Assemble/OrderDetail/:id',
      name: 'assembleOrderDetail',
      component: assembleOrderDetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/Assemble/Regiment/:id',
      name: 'assembleRegiment',
      component: assembleRegiment,
      meta: {
        title: '拼团商城'
      }
    },
    {
      path: '/Assemble/RegimentDetail/:id',
      name: 'assembleRegimentDetail',
      component: assembleRegimentDetail,
      meta: {
        title: '拼团详情'
      }
    },
    {
      path: '/Feedback/Index',
      name: 'feedbackIndex',
      component: feedbackIndex,
      meta: {
        title: '意见反馈'
      }
    },
    {
      path: '/Feedback/Detail',
      name: 'feedbackDetail',
      component: feedbackDetail,
      meta: {
        title: '反馈详情'
      }
    },
    {
      path: '/Turntable/Index',
      name: 'turntableIndex',
      component: turntableIndex,
      meta: {
        title: '大转盘'
      }
    },
    {
      path: '/Turntable/WinningRecord',
      name: 'turntableWinningRecord',
      component: turntableWinningRecord,
      meta: {
        title: '中奖记录'
      }
    },
    {
      path: '/Turntable/WinningList',
      name: 'turntableWinningList',
      component: turntableWinningList,
      meta: {
        title: '中奖名单'
      }
    },
    {
      path: '/Turntable/PerfectInfo',
      name: 'turntablePerfectInfo',
      component: turntablePerfectInfo,
      meta: {
        title: '完善信息'
      }
    }
  ]
})
// 路由钩子 路由改变跳转页面之前会触发
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // wx.init().then(data => {
  //   console.log(data)
  //   localStorage.user_id = data.user_id
  //   localStorage.openid = data.openid
  // }).catch(() => {
  // }).finally(() => {
    next()
  // })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js